<!-- 所有选手成绩查询 -->
 <template>
 <div>
    <div class="page-form" >
        <PageBack :title="title" />
        <div class="detail-wrap">             
            <el-table :data="tableData"  style="width: 100%" border>
                <el-table-column prop="title" label="赛事主题"/>
                <el-table-column prop="typename" label="赛事类型"/>       
                <el-table-column prop="date" label="赛事日期"/>
                <el-table-column prop="status" label="赛事状态">
                    <template  slot-scope="scope">
                    <el-tag :type="limitStatus(scope.row.status)">{{ scope.row.status }}</el-tag>
                </template>
                </el-table-column>
                <el-table-column  fixed="right" label="操作"  width="320">
                    <template slot-scope="scope">
                        <el-button @click="handleLook(scope.row)" type="text" size="small" v-if="scope.row.status !=='赛事取消'">成绩查询</el-button>
                        <el-button @click="handleGroupRank(scope.row)" type="text" size="small" v-if="scope.row.status !=='赛事取消'">团体排名</el-button>
                        <el-button @click="handleAll(scope.row)" type="text" size="small" v-if="scope.row.status !=='赛事取消'">总排名</el-button>  
                        <el-button  v-if="roles && scope.row.status !=='赛事取消'"
                            @click="handleQuery(scope.row)" type="text" size="small">支付查询</el-button>
                        <el-button @click="handleGradeDetail(scope.row)" 
                            v-if="scope.row.status === '积分发放'"
                            type="text" size="small">积分明细</el-button>
                    </template>
                </el-table-column>
            </el-table> 
        <pagination
            style="text-align:right"
            v-show="total > 10"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pagesize"
            @pagination="initData"/>
    </div>
    </div>
 </div>
 </template>
 
<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
import Breadcrumb from '@/components/Breadcrumb'
export default {
    components:{
        pagination,
        Breadcrumb,
        PageBack
    },
    data() {
        return {
            tableData: [],
            queryParams: {
                page: 1,
                pagesize: 10
            },
            total:0,            
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }, 
        roles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }     
    },
    created() {
    
    },
    mounted() {
        this.initData()
    },
    methods: {
        // 赛事管理查询
        initData(){
            let params = {
                opcode: this.$code.PubManageQuery,
                v_theme: '',
                start_date: 0,
                end_date: 0,
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    this.total = res.Data.SumCount    
                    this.tableData = result.map(item=>{
                        let eventTypeArr =  this.$global.eventTypeList.filter(i=>i.label === item['赛事类型'])
                        return{
                            title: item['赛事主题'],
                            date: item['赛事时间'],
                            serial: item['赛事标识'],
                            type: eventTypeArr[0].value,  
                            typename: eventTypeArr[0].name,    
                            status: item['赛事状态'],                        
                        }
                    })                                
                }
            })
        },
        // 赛事成绩详情
        scoreDetail(){
            let params = {
                opcode: this.$code.RankScoreDetail,
                i_serial_mark: ''
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    console.log(result)             
                }
            })
        },
        // 赛事排名-成绩
        handleLook(row){
            let params = {
                opcode: this.$code.RankScore,
                i_serial_mark: row.serial
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){
                        this.$router.push({
                            path: '/playerScore',
                            query:{
                                id: row.serial,
                            }
                        })
                    }else{
                        this.$message.error('暂无成绩')
                    }                               
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        handleAll(row){
            console.log(row)
            let params = {
                opcode: this.$code.RankScore,
                i_serial_mark: row.serial
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    if(result.length>0){
                        this.$router.push({
                            path:'/totalScore',
                            query:{
                                id:row.serial,
                                type: row.type
                            }
                        })
                    }else{
                        this.$message.error('暂无成绩')
                    }                               
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        handleGradeDetail(row){
            this.$router.push({
                path: '/gradeQuery',
                query:{
                    id: row.serial
                }                
            })
        },
        limitStatus(value){
            if(value==='赛事完成'){
                return 'success'
            }else if(value==='赛事取消'){
                return 'info'
            }else if(value==='赛事报名中' || value==='赛事中'){
                return 'danger'
            }else if(value==='积分发放'){
                return ''
            }
        },
        handleQuery(row){            
            let params = {
                opcode: this.$code.AdminIntroPayment,
                i_serial_mark: row.serial,
                c_status: 0,
                start_date: 0,
                end_date: 0,                
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let count = res.Data.SumCount
                    if(count > 1){
                        this.$router.push({
                            path: '/paymentQuery',
                            query:{
                                id: row.serial
                            }                
                        })
                    }else{
                        this.$message.error('暂无数据！')
                    }
                }
            })
        }, 
        handleGroupRank(row){
            console.log(row)
            let params = {
                opcode: this.$code.GroupRankCode,
                i_serial_mark: row.serial
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){                 
                    if(row.type === 3){
                        this.$router.push({
                            path: '/teamGroupRankQuery',
                            query:{
                                id: row.serial
                            }                
                        })
                    }else{
                        this.$router.push({
                            path: '/groupRankQuery',
                            query:{
                                id: row.serial
                            }                
                        })
                    }                    
                    // if(result.length > 0){
                    //     this.$router.push({
                    //         path: '/groupRankQuery',
                    //         query:{
                    //             id: row.serial
                    //         }                
                    //     })
                    // }
                }else{
                    this.$message.error(res.Message)
                }
            })
        }      
    }
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 </style>


// WEBPACK FOOTER //
// src/views/playerScore/PlayerScoreQuery.vue